import { CUSTOM_PROTOCOL } from "@/consts";

const manifest = {
  "name": location.hostname,
  "short_name": location.hostname,
  "scope": location.origin + '/',
  "start_url": location.origin + "/",
  "theme_color": 'black',
  "background_color": 'black',
  "display": "standalone",
  "icons": [
      // {
      //     "src": location.origin + "/images/logo-192.png",
      //     "sizes": "192x192",
      //     "type": "image/png",
      //     "purpose": "any"
      // },
      {
          "src": location.origin + "/static/images/logo-512.png",
          "sizes": "512x512",
          "type": "image/png",
          "purpose": "any"
      }
  ],
  "protocol_handlers": [
      {
          "protocol": CUSTOM_PROTOCOL,
          "url": location.origin + "/?pwaredirect=%s"
      }
  ],
  // "prefer_related_applications": false,
}

const createManifestLink = (json) => {
  const manifest = JSON.stringify(json)
  let link = document.createElement("link")
  link.rel = "manifest"
  link.href = "data:text/json;charset=utf-8," + encodeURIComponent(manifest)

  const existingManifest = document.querySelector('link[rel="manifest"]')
  if (existingManifest) {
    document.head.replaceChild(link, existingManifest)
  } else {
    document.head.appendChild(link)
  }
}

if (CUSTOM_PROTOCOL !== 'web+') createManifestLink(manifest)
